import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Amplify} from "aws-amplify";
import awsConfig from "./aws-config";
import '@aws-amplify/ui-react/styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
Amplify.configure(awsConfig);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App/>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
